export default __webpack_public_path__ + "static/ProValue_6@768-05ec63846880278d626725e2d202ff7d.png";